<template>
  <div class="comp-ly-skeleton-record">
    <jw-skeleton-line :rows="1" :lineHeight="26" />

    <div v-for="(i, index) in 2" :key="index" class="skeleton-contain">
      <jw-skeleton :animation="true">
        <jw-space direction="vertical" :style="{ width: '100%' }" :animation="true">
          <jw-skeleton-line :rows="1" :lineHeight="26" />
          <div class="record-info-shape">
            <jw-skeleton-line :rows="4" :lineHeight="18" :lineSpacing="8" />
          </div>
          <div class="record-info-btn"><jw-skeleton-line :lineHeight="20" :widths="[20]" v-for="(i, index) in 2" :key="index" /></div>
        </jw-space>
      </jw-skeleton>
    </div>
  </div>
</template>

<script setup>
import { reactive, ref } from 'vue';
console.log('1-开始创建组件-setup');
const data = reactive({});
const name = ref();
console.log(data, name);
</script>
<style scoped lang="less">
@import './ly-skeleton-record.less';
</style>
